export function isAppleDevice() {
  const userAgent = navigator.userAgent || '';
  const vendor = navigator.vendor || '';
  const platform = navigator.platform || '';

  if (vendor === 'Apple Computer, Inc.') return true;

  if (/iPhone|iPad|iPod|Mac/.test(userAgent)) return true;

  const isIOS = /iPhone|iPad|iPod/.test(userAgent) || (platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  const isMac = /Mac/.test(platform) && navigator.maxTouchPoints === 0;

  return isIOS || isMac;
}
